export default __webpack_public_path__ + "static/media/electrician-s-tool-min-min.cecbdc21.jpg";